module.exports = __webpack_public_path__ + "static/media/barracuda_logo_dark.5fd46f6a.svg";